import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';
import { MyProductsRoutingModule } from './my-products-routing.module';
import { ContextualActionModule } from './components/contextual-actions/contextual-action.module';
import { ProductPanelModule } from '../product-panel/product-panel.module';
import { ConfigureExportWidgetModule } from './components/configure-export-widget/configure-export-widget.module';

import { ScrollToService } from 'shared/base/scroll-to.service';
import { SearchPageService } from 'shared/search-page/search-page.service';
import { SideDrawerService } from 'shared/sidedrawer/sidedrawer.service';
import { MyProductsSearchService } from './search/my-products-search.service';
import { ArchivedProductsSearchService } from './components/archived-products-search/archived-products-search.service';

import { MyProductsComponent } from './my-products.component';
import { ViewArchivedProductsModalComponent } from './components/view-archived-products-modal/view-archived-products-modal.component';
import { ArchivedProductsSearchComponent } from './components/archived-products-search/archived-products-search.component';
import { MyProductsHeaderComponent } from './components/my-products-header/my-products-header.component';
import { MyProductsSearchComponent } from './components/my-products-search/my-products-search.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    MyProductsRoutingModule,
    ContextualActionModule,
    ProductPanelModule,
    ConfigureExportWidgetModule,
  ],
  declarations: [
    MyProductsComponent,
    ArchivedProductsSearchComponent,
    ViewArchivedProductsModalComponent,
    MyProductsHeaderComponent,
    MyProductsSearchComponent,
  ],
  exports: [MyProductsComponent],
  providers: [
    ScrollToService,
    SearchPageService,
    MyProductsSearchService,
    ArchivedProductsSearchService,
    SideDrawerService,
  ]
})
export class MyProductsModule {}
